import React from "react";
import {ToastContainer} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import AppRoutes from "./routes/AppRoutes";

function App() {
    return (
        <>
            <AppRoutes/>
            <ToastContainer/>
        </>
    );
}

export default App;
